/**
 * Taboo Coins Query Hooks
 */

import { useQuery } from '@tanstack/react-query';
import { canSeePaidDms } from '@/shared/lib/auth/permissions';
import { useAuthStore } from '@/shared/stores/auth-store';
import { coinsClient } from '../client/coins.client';
import { queryKeys } from '../query-keys';

export function useWallet() {
  // Auth-gated only BE-side (not subscription-gated); canSeePaidDms is the
  // TEMP tester rollout gate — remove from `enabled` at full release.
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const user = useAuthStore((s) => s.user);

  return useQuery({
    queryKey: queryKeys.coins.wallet(),
    queryFn: () => coinsClient.getWallet(),
    staleTime: 1000 * 30, // advisory balance; sends refresh it from balance_after
    enabled: isAuthenticated && canSeePaidDms(user),
  });
}
